import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';

const useStyles = makeStyles((theme: Theme) => {
  return {
    buttonContainer: {
      textAlign: 'center',
      padding: theme.spacing(3)
    },
    color: {
      backgroundColor: theme.palette.common.white
    }
  };
});

export interface ViewMoreButtonProps extends ButtonProps {
  ContainerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}
const ViewMoreButton: React.FC<ViewMoreButtonProps> = ({ ContainerProps, children, ...rest }) => {
  const classes = useStyles();
  return (
    <div className={classes.buttonContainer} {...ContainerProps}>
      <Button
        size="small"
        variant="outlined"
        startIcon={<AddCircleIcon />}
        {...rest}
        className={classes.color}
      >
        {children}
      </Button>
    </div>
  );
};

export default ViewMoreButton;
